import React from 'react';
import { Navigate } from 'react-router-dom';
import { isUserRole } from '../../utils/jwt';

const PartnerGuard = ({ children }) => {
  const role = isUserRole();

  if (role !== 'partner' && role !== 'admin') {
    return <Navigate to={`/${role}`} />;
  }

  return children;
};

export default PartnerGuard;
